export default [
    {
        path: '/tasks/:pageType',
        name: 'Todo',
        component: () => import('@/views/todo/Todo.vue'),
        meta: {
            authRequired: true,
            permission: 'todo',
            contentRenderer: 'sidebar-left',
            contentClass: 'todo-application',
            navActiveLink: 'Todo',

        }
    }
]
